import { CSSProperties, PropsWithChildren, MouseEvent } from 'react';
import { clsx } from 'clsx';
import styles from './Card.module.scss';
import { getDataIdGenerator } from '../shared/utils/dataId';
import { NumberRange } from '../shared/interfaces/number';

interface CardProps {
  tag?: 'div' | 'button';
  className?: string;
  dataId?: string;
  style?: CSSProperties;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  gridColumns?: Exclude<NumberRange<21>, 0>;
  title?: string;
  subtitle?: string;
  titleClass?: string;
}

export function Card({
  tag,
  dataId,
  children,
  className,
  onClick,
  style,
  gridColumns,
  titleClass,
  title,
  subtitle
}: PropsWithChildren<CardProps>) {
  const dataIdGenerator = getDataIdGenerator(dataId, 'card');

  const containerClasses = clsx(
    gridColumns && `d-grid grid-template-columns-${gridColumns}`,
    styles.card,
    className
  );
  const titleClasses = clsx(
    'text-bold',
    gridColumns && `grid-column-span-${gridColumns}`,
    titleClass
  );

  const commonProps = {
    style,
    className: containerClasses,
    'data-id': dataIdGenerator(''),
    onClick
  };

  const Tag = tag || 'div';

  return (
    <Tag {...commonProps}>
      {title ? (
        <div className={titleClasses}>
          {title}

          {subtitle ? <div className='text-normal text-secondary mt-1'>{subtitle}</div> : null}
        </div>
      ) : null}

      {children}
    </Tag>
  );
}
